.#{$namespace}-checkbox {
	--checkbox-size: 14px;
	--checkbox-font-size: #{$font-size};
	--checkbox-input-height: 14px;
	--checkbox-border-radius: 2px;

	position: relative;
	display: inline-flex;
	align-items: center;
	margin-right: 24px;
	font-size: var(--checkbox-font-size);
	color: $text-secondary-color;
	font-weight: 500;
	cursor: pointer;
	user-select: none;
	white-space: nowrap;
	height: $control-height;

	&--large {
		--checkbox-size: 16px;
		--checkbox-input-height: 16px;
		height: calc(#{$control-height} + 8px);
	}

	&--small {
		--checkbox-size: 12px;
		--checkbox-input-height: 12px;
		--checkbox-font-size: 12px;
		height: calc(#{$control-height} - 8px);
	}

	&.is-bordered {
		padding: 0 12px;
		border: 1px solid $border-color;
		border-radius: 4px;
		box-sizing: border-box;

		&.is-checked {
			border-color: color-token(primary);
		}

		&.is-disabled {
			border-color: $border-lighter-color;
		}
	}

	&.is-disabled {
		color: $text-disabled-color;
		cursor: not-allowed;
	}
}

.#{$namespace}-checkbox__input {
	position: relative;
	display: inline-flex;
	white-space: nowrap;
	outline: none;
	cursor: pointer;

	&.is-disabled {
		cursor: not-allowed;
	}
}

.#{$namespace}-checkbox__original {
	opacity: 0;
	outline: none;
	position: absolute;
	margin: 0;
	width: 0;
	height: 0;
	z-index: -1;
}

.#{$namespace}-checkbox__inner {
	position: relative;
	/** flex 居中 Svg，不再靠 ::after 绝对定位 */
	display: inline-flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	width: var(--checkbox-input-height);
	height: var(--checkbox-input-height);
	background-color: $white-color;
	border: 1px solid $border-color;
	border-radius: var(--checkbox-border-radius);
	transition:
		border-color 0.15s,
		background-color 0.15s;

	.#{$namespace}-svg {
		/** select / semi-select 笔画更粗；font-size 跟框等高，viewBox 四周空靠缩放吃掉 */
		font-size: var(--checkbox-input-height);
		color: $white-color;
		pointer-events: none;
		opacity: 0;
		transform: scale(0.6);
		transition:
			transform 0.15s ease-in 0.05s,
			opacity 0.15s ease-in 0.05s;
	}
}

.#{$namespace}-checkbox__input.is-checked .#{$namespace}-checkbox__inner,
.#{$namespace}-checkbox__input.is-indeterminate .#{$namespace}-checkbox__inner {
	background-color: color-token(primary);
	border-color: color-token(primary);

	.#{$namespace}-svg {
		opacity: 1;
		transform: scale(1);
	}
}

.#{$namespace}-checkbox__input.is-disabled .#{$namespace}-checkbox__inner {
	background-color: $border-lighter-color;
	border-color: $border-light-color;
	cursor: not-allowed;

	.#{$namespace}-svg {
		color: $text-disabled-color;
	}
}

.#{$namespace}-checkbox__input.is-disabled.is-checked
	.#{$namespace}-checkbox__inner,
.#{$namespace}-checkbox__input.is-disabled.is-indeterminate
	.#{$namespace}-checkbox__inner {
	background-color: color-token(primary, light-5);
	border-color: color-token(primary, light-5);

	.#{$namespace}-svg {
		color: $white-color;
	}
}

.#{$namespace}-checkbox__input.is-focus .#{$namespace}-checkbox__inner {
	border-color: color-token(primary);
}

.#{$namespace}-checkbox__label {
	display: inline-block;
	padding-left: 8px;
	line-height: 1;
	font-size: var(--checkbox-font-size);
}

.#{$namespace}-checkbox-group {
	display: inline-flex;
	flex-wrap: wrap;
	align-items: center;
	font-size: $font-size;

	&.is-vertical {
		flex-direction: column;
		align-items: flex-start;

		.#{$namespace}-checkbox {
			margin-right: 0;
			margin-bottom: 8px;
			height: auto;
		}
	}

	&.is-horizontal {
		flex-direction: row;
	}

	.#{$namespace}-checkbox:last-of-type {
		margin-right: 0;
		margin-bottom: 0;
	}
}

.#{$namespace}-checkbox-button {
	position: relative;
	display: inline-flex;
	margin: 0;

	&--large {
		.#{$namespace}-checkbox-button__inner {
			padding: 10px 16px;
			font-size: $font-size;
		}
	}

	&--small {
		.#{$namespace}-checkbox-button__inner {
			padding: 5px 12px;
			font-size: 12px;
		}
	}

	&.is-checked {
		.#{$namespace}-checkbox-button__inner {
			color: $white-color;
			background-color: color-token(primary);
			border-color: color-token(primary);
			box-shadow: -1px 0 0 0 color-token(primary);
		}
	}

	&.is-disabled {
		cursor: not-allowed;

		.#{$namespace}-checkbox-button__inner {
			color: $text-disabled-color;
			background-color: $border-lighter-color;
			border-color: $border-light-color;
			box-shadow: none;
			cursor: not-allowed;
		}
	}

	&.is-disabled.is-checked {
		.#{$namespace}-checkbox-button__inner {
			color: $white-color;
			background-color: color-token(primary, light-5);
			border-color: color-token(primary, light-5);
		}
	}
}

.#{$namespace}-checkbox-button__original {
	opacity: 0;
	outline: none;
	position: absolute;
	margin: 0;
	z-index: -1;
}

.#{$namespace}-checkbox-button__inner {
	display: inline-block;
	line-height: 1;
	white-space: nowrap;
	vertical-align: middle;
	background: $white-color;
	border: 1px solid $border-color;
	border-left: 0;
	color: $text-secondary-color;
	font-size: $font-size;
	font-weight: 500;
	padding: 8px 16px;
	cursor: pointer;
	transition:
		color 0.15s,
		background-color 0.15s,
		border-color 0.15s;
}

.#{$namespace}-checkbox-button:first-child {
	.#{$namespace}-checkbox-button__inner {
		border-left: 1px solid $border-color;
		border-radius: 4px 0 0 4px;
		box-shadow: none;
	}
}

.#{$namespace}-checkbox-button:last-child {
	.#{$namespace}-checkbox-button__inner {
		border-radius: 0 4px 4px 0;
	}
}

.#{$namespace}-checkbox-button:first-child:last-child {
	.#{$namespace}-checkbox-button__inner {
		border-radius: 4px;
	}
}
